// src/pages/Login.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

//const BACKEND_URL = 'http://localhost:3001';
const BACKEND_URL = '/api';

export default function Login() {
  const navigate = useNavigate();

  const [isVisible, setIsVisible] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // L'app si apre anche senza rete, ma l'accesso no: la verifica delle
  // credenziali la fa il server. Senza dirlo, il tecnico in cantina digita
  // la password e riceve un errore generico che sembra una password
  // sbagliata.
  const [senzaRete, setSenzaRete] = useState(
    typeof navigator === 'undefined' ? false : !navigator.onLine
  );

  useEffect(() => {
    setIsVisible(true);

    const aggiorna = () => setSenzaRete(!navigator.onLine);
    window.addEventListener('online', aggiorna);
    window.addEventListener('offline', aggiorna);
    return () => {
      window.removeEventListener('online', aggiorna);
      window.removeEventListener('offline', aggiorna);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    if (typeof navigator !== 'undefined' && !navigator.onLine) {
      setError(
        'Per accedere serve la rete: le credenziali le controlla il server. ' +
          'Entra prima di andare in cantiere, poi il gestionale funziona anche offline.'
      );
      return;
    }

    try {
      //const res = await fetch(`${BACKEND_URL}/api/login`, {
      const res = await fetch(`${BACKEND_URL}/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: email, password }),
      });

      if (!res.ok) {
        let msg = 'Credenziali non valide';
        try {
          const errData = await res.json();
          if (errData?.error) msg = errData.error;
        } catch (_) {}
        throw new Error(msg);
      }

      const data = await res.json();

      // token e refresh token
      localStorage.setItem('token', data.token);
      localStorage.setItem('refreshToken', data.refreshToken);

      // ruolo (può servire in dashboard / gestione utenti)
      if (data.role) {
        localStorage.setItem('role', data.role);
      }

      // foto profilo
      if (data.profilePicture) {
        const fullUrl = data.profilePicture.startsWith('http')
          ? data.profilePicture
          : `${BACKEND_URL}${data.profilePicture}`;
        localStorage.setItem('profilePicture', fullUrl);
      } else {
        localStorage.setItem('profilePicture', '/default-avatar.jpg');
      }

      // flag per obbligo cambio password
      if (data.mustChangePassword) {
        localStorage.setItem('mustChangePassword', 'true');
        navigate('/cambia-password');
      } else {
        localStorage.removeItem('mustChangePassword');
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message || 'Errore durante il login');
    }
  };

  return (
    <div
      className={`text-white font-bold transition-opacity duration-[2000ms] ease-in-out ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <form
        className="max-w-md mx-auto mt-20 p-6 bg-white shadow-md rounded"
        onSubmit={handleLogin}
      >
        <h1 className="text-2xl font-bold mb-4 text-gray-800">
          Accedi al tuo account
        </h1>

        {senzaRete && (
          <div className="mb-4 rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900">
            <strong className="block">Sei senza rete</strong>
            Per accedere serve la connessione: le credenziali le controlla il
            server. Una volta entrato, il gestionale funziona anche offline.
          </div>
        )}

        <input
          type="email"
          placeholder="Email"
          className="w-full mb-3 p-2 border rounded text-black"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          className="w-full mb-4 p-2 border rounded text-black"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          type="submit"
          disabled={senzaRete}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 transition disabled:opacity-50 disabled:hover:bg-blue-600"
        >
          Login
        </button>

        {/* Link recupero password */}
        <button
          type="button"
          className="w-full mt-2 text-sm text-blue-600 hover:underline font-normal"
          onClick={() => navigate('/recupero-password')}
        >
          Password dimenticata?
        </button>

        {error && (
          <p className="text-red-500 mt-2 text-sm font-normal">{error}</p>
        )}
      </form>
    </div>
  );
}
